<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 position-relative">
        <Notification
          :show="showNotification"
          :data="notificationData"/>
        <div
          class="content"
          :class="adminMode ? 'admin' : 'bg-light'"
          :style="{'height': height}"
          id="content">
            <router-view :key="$route.fullPath"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Notification from './Notification.vue'


  export default {
    props:['activeView', 'adminMode'],
    data(){
      return{
        height: null
      }
    },
    methods:{
      setHeight(){
        const nav = document.getElementById('topNav').clientHeight
        this.height = window.innerHeight - nav + 2 + 'px'
      }
    },
    created(){
      // Set app height on window size change
      window.addEventListener('resize', function(){
        this.setHeight()
      }.bind(this))
      // Set app height on orientation change
      window.addEventListener('orientationchange', function(){
        this.setHeight()
      }.bind(this))
    },
    mounted(){
      this.setHeight()
    },
    components:{
      Notification
    },
    computed:{
      showNotification(){return this.$store.getters.showNotification},
      notificationData(){return this.$store.getters.notificationData}
    }
  }
</script>

<style scoped>
  .content{
    overflow: hidden;
    overflow-y: scroll;
    padding-bottom: 8em;
    position: absolute;
    right: 11px;
    left: 0;
    bottom: 0;
    top: -1px;
    height: 100svh;
    background: var(--bs-body-bg) !important;
  }

  @media(max-width: 991px){
    .content {
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      right: 0px;
      padding: 0px 10px;
      padding-bottom: 8em;
    }
    .content::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Edge */
    }
  }

  .bg-light{
    border: 1px solid var(--bs-primary);
  }
  .admin{
    background: var(--bs-admin-rgb) !important;
  }
</style>